import { WorkerSynchronizer, WorkerSynchronizerSpawner } from '@bcf-v2-platforms/platform-worker/worker-synchronizer';

export function createUrlChannel(spawner: WorkerSynchronizerSpawner): WorkerSynchronizer<string> {
  return spawner.spawn('_activatedUrl+url');
}

export function createFullUrlChannel(spawner: WorkerSynchronizerSpawner): WorkerSynchronizer<string> {
  return spawner.spawn('_activatedUrl+fullUrl');
}
